import { Autocomplete, TextField } from '@mui/material';
import { VENDOR_CHOICES } from './constants';

const VendorField = ({
  disabled = false,
  onChange,
  value,
}: {
  disabled?: boolean;
  onChange: (value: string) => void;
  value: string;
}) => {
  if (disabled) {
    return (
      <TextField
        disabled
        helperText="Vendor that the order was requested with."
        label="Vendor"
        size="small"
        value={value}
      />
    );
  }

  return (
    <Autocomplete
      freeSolo
      inputValue={value}
      options={[...VENDOR_CHOICES]}
      onInputChange={(_, next, reason) => {
        if (reason === 'reset' && !next && value) return;
        onChange(next);
      }}
      renderInput={(params) => (
        <TextField {...params} helperText="Vendor that the order was requested with." label="Vendor" size="small" />
      )}
      value={value || null}
    />
  );
};

export default VendorField;
